export enum Playbooks {
    SMART = 'SmartSearch',
    NOVELTY = 'NoveltySearch',
    DESIGN = 'DesignSearch',
    LITERATURE = 'LiteratureSearch',
    LITERATURENOVELTY = 'LiteratureNoveltySearch',
    MATERIAL = 'MaterialSearch',
    LITERATUREMATERIAL = 'LiteratureMaterialSearch',
    MATERIALNOVELTY = 'MaterialNoveltySearch',
    LITERATUREMATERIALNOVELTY = 'LiteratureMaterialNoveltySearch'
}

export enum PlaybookQuery {
    SMART = 'query',
    NOVELTY = 'novelty',
    WS = 'workspace',
    DESIGN = 'design',
    UTILITY = 'utility'
}

export type I_Playbook = `${Playbooks}`
export type I_PlaybookQuery = `${PlaybookQuery}`

export interface IStructureQuery {
    type: string,
    value: string
}
